import { axiosClient } from "@/shared/api/axios-client";

/**
 * Resumen ligero de cada solicitud · espejo del DTO MiSolicitudDto del backend.
 * Lo usa el card de "Última actividad" del dashboard para listar las 5
 * más recientes (sin abrir la página completa de /solicitudes).
 */
export interface MiSolicitudDto {
  id: string;
  numeroSolicitud: number;
  /** Folio formateado · ver doc en `SolicitudResumen.folio` (15 chars con sociedad, 11 sin). */
  folio: string;
  estado: string;
  tipo: string | null;
  subtipo: string | null;
  organizacionNombre: string | null;
  /** Área a la que pertenece · null hasta que se capturan datos generales. */
  areaNombre: string | null;
  /** Razón social del proveedor asignado · null hasta el paso 4 del wizard. */
  proveedorRazonSocial: string | null;
  /** Número de proveedor · null hasta el paso 4. */
  proveedorNumero: number | null;
  /** Descripción del primer concepto del CFDI · null si no hay CFDI. */
  descripcionPrimerConcepto: string | null;
  totalCfdi: number | null;
  monedaCfdi: string | null;
  /** Total del prorrateo confirmado · respaldo del importe cuando no hay CFDI con total. */
  totalProrrateo: number | null;
  /** Moneda de la solicitud (DatosInvoice) · para formatear `totalProrrateo`. */
  monedaProrrateo: string | null;
  rfcEmisor: string | null;
  cantidadDocumentos: number | null;
  flujoNivelActual: number | null;
  flujoCantidadNiveles: number | null;
  /**
   * Roles autorizadores del nivel actual (CSV) · lo necesita `etiquetaEstado`
   * para distinguir "En autorización Mesa de Control" del resto de los niveles.
   * El backend ya lo enviaba; este espejo lo omitía y por eso el dashboard
   * mostraba una etiqueta desincronizada.
   */
  flujoRolActual: string | null;
  tieneRechazoPendiente: boolean;
  enviadaAContabilizacion: boolean;
  fechaInicio: string;
  fechaUltimoEvento: string;
}

export async function listarMisSolicitudes(): Promise<MiSolicitudDto[]> {
  // El endpoint es PAGINADO (envelope { items, total, ... }) · el card de
  // "Última actividad" solo necesita las más recientes: el orden default del
  // server ya es FechaUltimoEvento desc, así que la primera página basta.
  const { data } = await axiosClient.get<{ items: MiSolicitudDto[] }>(
    "/api/solicitudes/mias",
    { params: { page: 1, pageSize: 12 } },
  );
  return data.items;
}
